import { Loading } from "@/components/ui/loading";
import { RegionsRoute } from "@/modules/regions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/regions/")({
	component: RegionsRoute,
	pendingComponent: Loading,
});
